import { VehicleCostSnapshot } from '@/components/Approval/@components/VehicleCost';
import { parseVehicleCostContent } from '@/utils/approval/vehicleCost';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 93 차량유지비 신청 — 저장 content 그대로(레거시 조회와 동일) */
const VehicleCostSlot = ({ data }: ContentExtraProps) => {
  const content = parseVehicleCostContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <VehicleCostSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default VehicleCostSlot;
